// resources/js/vue/modules/invoices/helpers/recipient.js
import { RecipientType } from '../types'

export function createEmptyRecipient(type = RecipientType.INDIVIDUAL) {
	return {
		type,
		person: {
			firstName: '',
			lastName: '',
			middleName: '',
			phone: '',
			email: '',
			RNOKPP: '',
			passport: '',
			birthDate: '',
			address: '',
			city: '',
			country: '',
			postCode: '',
			state: '',
		},
		legal: {
			name: '',
			EDRPOU: '',
			IBAN: '',
			actualCountry: '',
			country: '',
			city: '',
			street: '',
			building: '',
			vat: false,
			MFO: '',
		},
	}
}
